import React from 'react';
import ReactDOM from 'react-dom/client';
import RoutesApp from './comps/routes';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RoutesApp />
  </React.StrictMode>
);

reportWebVitals();
